import React from "react";
import PropTypes from "prop-types";
import TopNav from "./TopNav";
import { DomainScopes } from "../../constants/DomainConstants";
import Row from "../common/Row";

const PageHeader = ({ title, intro, showTopNav, topNavTabSettings, scope, accountId, accountType }) => {
	const titleItem = title ? <h1 className="page-title">{title > 100 ? title.substring(0, 10) : title}</h1> : null;
	const introItem = intro ? scope === DomainScopes.DEFAULT ? <Row>{intro}</Row> : <div className="page-subtitle">{intro}</div> : null;
	const topNavItem = showTopNav ?
		<TopNav topNavTabSettings={topNavTabSettings} scope={scope} accountId={accountId} accountType={accountType} /> : null;

	return (
		<section className="o-page__header">
			<div className="c-container u-clear">
				<div className="o-page__header__section">
					{titleItem}
					{introItem}
				</div>
				{topNavItem}
			</div>
		</section>
	);
};

PageHeader.propTypes = {
	title: PropTypes.string,
	intro: PropTypes.string,
	showTopNav: PropTypes.bool.isRequired,
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string,
	accountId: PropTypes.string,
	accountType: PropTypes.string
};

export default PageHeader;
